import { render, staticRenderFns } from "./RestaurantAnimatedModal.vue?vue&type=template&id=550b076d&scoped=true&"
import script from "./RestaurantAnimatedModal.vue?vue&type=script&lang=js&"
export * from "./RestaurantAnimatedModal.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantAnimatedModal.vue?vue&type=style&index=0&id=550b076d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550b076d",
  null
  
)

export default component.exports